<template>
  <AccountPanel title="Lista ofert">
    <div class="table-responsive offers">
      <table class="table table-striped">
        <thead>
          <tr>
            <th scope="col">nr oferty</th>
            <th scope="col">data dodania</th>
            <th scope="col">termin ważności</th>
            <th scope="col">status</th>
            <th scope="col">netto</th>
            <th scope="col">vat</th>
            <th scope="col">brutto</th>
            <th>akcje</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="offer in offers">
            <th scope="row">
              <span class="user-mobile-label">nr oferty</span>
              <span>{{ offer.id }}</span>
            </th>
            <td>
              <span class="user-mobile-label">data dodania</span>
              <span>{{ offer.added.substr(0, 10) }}</span>
            </td>
            <td>
              <span class="user-mobile-label">termin ważności</span>
              <span>{{ offer.expire.substr(0, 10) }}</span>
            </td>
            <td>
              <span class="user-mobile-label">status</span>
              <span>{{ offer.status == "NEW" ? "Nowa" : "Wykonana" }}</span>
            </td>
            <td>
              <span class="user-mobile-label">netto</span>
              <span>{{ priceToString(offer.total_net, "PLN") }}</span>
            </td>
            <td>
              <span class="user-mobile-label">vat</span>
              <span>{{ priceToString(offer.total_tax, "PLN") }}</span>
            </td>
            <td>
              <span class="user-mobile-label">brutto</span>
              <span>{{ priceToString(offer.total_gross, "PLN") }}</span>
            </td>
            <td>
              <button
                @click="goToOffer(offer.id)"
                title="Pokaż szczegóły oferty"
                class="btn btn-secondary btn-sm"
              >Szczegóły</button>
              <button @click="removeOffer(offer.id)" title="Usuń" class="btn btn-dark btn-sm">Usuń</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </AccountPanel>
</template>

<script>
import { mapState } from "vuex";
import CalculatePrice from "./../../products/src/product/CalculatePrice";
import AccountPanel from "./../../account/src/account/AccountPanel.vue";

export default {
  data() {
    return {
      offers: []
    };
  },
  components: {
    AccountPanel
  },
  methods: {
    ...CalculatePrice(),
    goToOffer(offerId) {
      this.$router.push({ name: "offerPage", params: { offerId: offerId } });
    },
    async removeOffer(offerId) {
      this.offers = this.offers.filter(o => o.id != offerId);
      this.$store.dispatch("offer/removeOffer", offerId);
      this.$noty.error("Oferta została usunięta!");
    }
  },
  async beforeMount() {
    this.offers = await this.$store.dispatch("offer/offers");
  }
};
</script>



// WEBPACK FOOTER //
// src/components/offer/src/OfferList.vue